import React from "react";
import NavigationBar from "../../General/NavigationBar/NavigationBar";
import SalesSidebar from "../SalesSidebar/SalesSidebar";

const SalesLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<SalesSidebar />}>{children}</NavigationBar>
);

export default SalesLayout;
